// extracted by mini-css-extract-plugin
export default {"invalidDataError":"addFrequentProductStyle_invalidDataError__syIj0"};